import * as React from "react"
import { formatDate } from "@ui-seeker/utils"
import { TooltipSeeker } from "@ui-seeker/core"
import { Box, Typography } from "@mui/material";

import { IconDataBlock } from "@components";
import TitleTooltip from "./TitleTooltip";

export default function BestPositionBlock({
    keys, date, vertical, horizontal, allData, firstIcon='arrows-up-down', secondIcon='arrows-left-right', propsTitle,
    thirdIcon, extraPosition,
}) {

    const tooltipStyles = {
        background: 'linear-gradient(110deg, rgba(210,210,210,1) 0%, rgba(230,230,230,1) 100%)',
        boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, .1), 0px 6px 10px 0px rgba(0, 0, 0, .03), 0px 1px 18px 0px rgba(0, 0, 0, .03), 0px 1px 18px 0px rgba(0, 0, 0, .03)'
    }

    return <TooltipSeeker title={<TitleTooltip allData={allData} keys={keys}/>} sx={tooltipStyles} {...propsTitle}>
        <Box sx={{textAlign: 'center'}}>
            <Typography variant="body2" gutterBottom >
                {formatDate(date, { isString: true, format: 'yyyy/mm/dd', receivedFormat: 'yyyymmdd'  })}
            </Typography>
            <IconDataBlock value={vertical} icon={firstIcon} />
            <IconDataBlock value={horizontal} icon={secondIcon} />
            { !!extraPosition && !!thirdIcon && <IconDataBlock value={extraPosition} icon={thirdIcon} /> }
        </Box>
    </TooltipSeeker>
}